import React from 'react';

const DeviceReportsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default DeviceReportsPage;
